import React from "react"
import ArticleMeta from "../../components/article-meta"
import CommentsForm from "../../components/comments-form"
import Layout from "../../components/layout/layout"
import SEO from "../../components/seo"
import { Articles } from "../../data/articles"

const article = Articles.getBySlug("motivating-people")

export default () => (
  <Layout>
    <SEO
      title={article.title}
      keywords={[article.title, ...article.categories]}
    />
    <div id="section">
      <div className="main-article">
        <ArticleMeta article={article} />

        <div className="article-content">
          <img
            src={article.image}
            className="attachment-wide-thumbnail"
            alt={article.title}
          />

          <p>
            Forward-thinking companies pay a great deal of attention to employee
            engagement. But should they?
          </p>
          <p>
            Over the past decades, scientific research has provided compelling
            evidence for the idea that engaged employees perform better, are
            less likely to leave or burn out, and more likely to display
            organizational citizenship. Employee engagement has also been found
            to correlate positively with business level performance and other
            measures of organizational effectiveness.
          </p>
          <p>
            At the same time, the true value of engagement would come not from
            correlation, but from causation: if employee engagement can be shown
            to predict and cause future organizational outcomes, there would be
            a clear justification for enhancing employee engagement.
          </p>
          <p>
            So, does engagement actually cause higher performance, or are
            high-performing employees just more engaged?
          </p>
          <p>
            Surprisingly, there is not much empirical evidence to answer this
            question. That’s because to demonstrate causality, engagement and
            performance data would have to be gathered at different points in
            time, to test whether increases in engagement levels translate into
            subsequent increases in performance, and whether decreases in
            engagement levels translate into subsequent decreases in
            performance. This approach would also let you see whether
            performance gains drove engagement, or vice versa.
          </p>
          <p>
            In one of the few robust studies to examine this issue, Ben
            Schneider and colleagues mined archival engagement and performance
            data for several Fortune 100 companies. Their study is particularly
            important because it tested the degree to which company-wide gains
            in engagement resulted in higher profits and stock valuations, as
            well as the reverse.
          </p>

          <p>
            Their findings highlight the complex relationship between engagement
            and performance: although engagement gains did predict subsequent
            increases in organizational financial and market performance, the
            reverse was also true. In fact, gains in financial and market
            performance tended to boost certain aspects of employee engagement
            more than the other way around.
          </p>
          <p>
            These results suggest that companies with more engaged workers may
            end up performing better, but that it is just as likely that high
            performing companies end up with more engaged employees, simply
            because they are more successful. Indeed, when businesses do well
            they can provide employees with better pay and benefits, which will
            result in a higher sense of security, and even an ego boost.
          </p>
          <p>
            Although Schneider’s research focused on the organizational level –
            in other words, how much employees felt engaged with their employer,
            rather than their job or manager – recent studies have also examined
            the drivers of engagement at the individual level of analysis.
          </p>
          <p>
            In one of these studies, Gallup investigated whether leaders are
            more likely to engage employees by building close relationships and
            attending to their wellbeing, or simply focusing on their
            performance. Gallup’s findings suggest that the most effective
            leaders don’t just motivate people by focusing on engagement; they
            are also focused on enhancing employees’ performance. For example,
            employees are seven times more likely to be engaged when they report
            that their managers are aware of the tasks and projects that they
            are working on, which suggests that when bosses make their employees
            accountable, their employees are more engaged. Conversely, when
            employees perceive that their managers have no clue about what they
            are working on, they are 15 times more likely to be disengaged than
            engaged.
          </p>

          <CommentsForm title={article.title} />
        </div>
      </div>
    </div>
  </Layout>
)
